export default "__VITE_ASSET__BMBXofVx__"